import React from "react";

import Form from "./Form";

const Index: React.FC<{ onClose: () => void }> = (): React.ReactElement => {
  return <Form />;
};

export default Index;
